RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const PostTagsCompanyCountCell = _.defaults({
        getPopover: function (data, metric, metrics) {
            const me = this;

            const postTagId = _.head(data);
            const postTagName = RivalIQ.postTags.utils.makePostTagName(_.get(me, ['dashboardModel', 'postTagsById']), postTagId);

            return new RivalIQ.views.metric.CompanyCountCellPopover({
                popoverName: postTagName,
                data: data,
                metrics: metrics
            });
        }
    }, RivalIQ.views.metric.CompanyCountCell);

    function getBaseMetric() {
        return new RivalIQ.models.MetricDefinition({
            concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POST_TAG_IDS.id,
            dimensions: ['post_tag_id']
        });
    }

    function normalizeMetricColumns(props) {

        const me = this;

        me.metrics = _.clone(props.metrics);

        // Always include post tag name as the first column
        me.metrics.unshift({
            dimensions: ['post_tag_id'],
            property: 'name',
            dimensionView: App.widgets.CompanyCell,
            valueFormat: function (value) {
                const postTagId = _.last(value);

                if (postTagId === '__SUMMARY_ROW__') {
                    const postWord = RivalIQ.data.channels.get(props.channel).get('postName');
                    return Marionette.TemplateCache.get('#allPostsRowCellTemplate')({
                        postWord
                    });
                }

                const postTagName = RivalIQ.postTags.utils.makePostTagName(me.postTagsById || {}, postTagId);
                return RivalIQ.postTags.utils.postTagHtml(postTagName);
            },
            mustInclude: function (data) {
                return _.head(data) === '__SUMMARY_ROW__';
            },
            sort: function () {
                return function (postTagIdA, postTagIdB, sortOrder) {
                    const getPostTagName = (postTagId) => {
                        if (postTagId === '__SUMMARY_ROW__') {
                            return 'All Posts';
                        } else if (postTagId === '__UNTAGGED__') {
                            return 'Untagged';
                        }

                        return _.get(me, ['postTagsById', postTagId, 'tag_name'], postTagId);
                    };
                    const tagA = getPostTagName(postTagIdA);
                    const tagB = getPostTagName(postTagIdB);
                    return RivalIQ.utils.sort.default(tagA, tagB, sortOrder);
                };
            }
        });

        const postCountMetric = _.find(me.metrics, {
            property: 'count'
        });
        if (postCountMetric) {
            // post count, if present, should be at position 1 or 2
            // (2 if there's a companies_using metric, handled below)
            _.pull(me.metrics, postCountMetric);
            me.metrics.splice(1, 0, postCountMetric);
        }

        const companyCountMetric = _.find(me.metrics, {
            property: 'companies_using'
        });
        if (companyCountMetric) {
            companyCountMetric.cellView = _.constant(_.extend({
                dashboardModel: me
            }, PostTagsCompanyCountCell));

            // companies_using, if present, should be at position 1
            _.pull(me.metrics, companyCountMetric);
            me.metrics.splice(1, 0, companyCountMetric);
        }

        me.metricsCollection = me.metrics;
        RivalIQ.models.MetricDefinition.build(me, me.metric, {}, 'metricsCollection');

        _.defaults(props, {
            orderBy: me.metrics.length
        });
    }

    const PostTagsTable = App.widgets.PostAggregatesTableView.mixin({
        mixins: {
            loadTags: RivalIQ.apps.SocialPosts.mixins.PostTablesLoadData,
            postTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights
        },

        template: '#normalizeHeightsMetricTableTemplate',

        emptyView: Marionette.ItemView.extend({
            template: '#normalizeHeightsMetricTableEmptyTemplate'
        }),

        reloadOnAnyPostTagChange: true,

        isTableExpandable: _.constant(true),

        loadData: function () {
            const me = this;

            return RivalIQ.apps.SocialPosts.mixins.PostTablesLoadData.loadData.apply(me)
                .then(function () {
                    let emptyTemplate;
                    if (_.isEmpty(me.dashboardModel.postTagsById)) {
                        emptyTemplate = '#postTagsNoTagsTemplate';
                    } else {
                        emptyTemplate = '#postTagsNoResultsTemplate';
                    }
                    me.options.emptyView = Marionette.ItemView.extend({
                        template: emptyTemplate
                    });
                });
        }
    });

    const FooterView = RivalIQ.apps.Dashboard.views.PanelFooter.extend({
        template: '#socialPostsPostTagsFooterTemplate',
        className: 'panel-footer'
    });

    const ShowSummaryRowSwitch = RivalIQ.views.ShowSummaryRowSwitch = RivalIQ.views.ItemView.mixin({
        attributes: {
            style: 'width: 100%'
        },

        template: '#socialPostsShowSummaryRowSwitchTemplate',

        ui: {
            showBtn: '.x-show',
            hideBtn: '.x-hide'
        },

        events: {
            'click @ui.showBtn': 'onShowClicked',
            'click @ui.hideBtn': 'onHideClicked'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        _updateShowSummaryRow: function (includeSummaryRow) {
            const me = this;

            me.ui.showBtn.toggleClass('active', includeSummaryRow);
            me.ui.hideBtn.toggleClass('active', !includeSummaryRow);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ToggledShowSummaryRow, {
                includeSummaryRow: includeSummaryRow
            });

            me.dashboardModel.save({
                includeSummaryRow: includeSummaryRow
            }).fail(function () {
                RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
            });
        },

        onShowClicked: function () {
            const me = this;
            me._updateShowSummaryRow(true);
        },

        onHideClicked: function () {
            const me = this;
            me._updateShowSummaryRow(false);
        },

        serializeData: function () {
            const me = this;

            return {
                postName: RivalIQ.data.channels.get(me.getProp('channel')).get('postName'),
                includeSummaryRow: me.getProp('includeSummaryRow') || false
            };
        }
    });

    const Panel = widgets.PostDimensionDetailsPanel.extend({
        showActions: function () {
            const me = this;

            me.actions.show(new ShowSummaryRowSwitch({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: true
            });

            widgets.PostDimensionDetailsPanel.prototype.showActions.call(me);
        }
    });

    const PostTagsTableWidget = widgets.PostDimensionTable.extend({
        title: 'Post Tags',
        description: RivalIQ.strings.social_posts_post_tags_description,
        getFilenameTitle: _.constant('post tags'),
        getBaseMetric: getBaseMetric,
        normalizeMetricColumns: normalizeMetricColumns,
        panelClassName: 'post-tags-aggregate-table',
        expansionTracking: RivalIQ.tracking.metric.SocialPostsExpandedTableRow,

        getView: _.constant(PostTagsTable),
        panelView: Panel,
        detailPanelView: Panel,

        footerView: FooterView,
        hasFooter: _.constant(true),

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                limit: 8,
                dimension: 'companyId',
                hideManageColumns: false,
                showDescriptions: true,
                showPostTagActionsInModal: true
            });

            if (props.instanceId || props.widgetId) {
                props.limit = -1;
            }

            if (props.postTagIds && !props.postTagExclude && props.postTagConjunction !== 'AND') {
                props.limitPostTagIds = true;
            } else {
                props.limitPostTagIds = false;
            }

            return widgets.PostDimensionTable.prototype.processProps.apply(me, arguments);
        },

        csvExportProps: function () {
            const me = this;

            return {
                type: 'postTags',
                metric: me.metric.build({
                    limit: -1
                }).serialize()
            };
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_POST_TAGS_TABLE, PostTagsTableWidget);

});
